import '../App.css'
import Bottone from './Bottone'

function Menu (){
    return(
        <div className='Menu'>
            <Bottone nome="armadietto"/>
            <Bottone nome="buco"/>
            <Bottone nome="cassapanca"/>
            <Bottone nome="marrone"/>
            <Bottone nome="puntozero"/>
            <Bottone nome="rodolfo"/>
        </div>
    )
}

export default Menu;

